import AbsComponent from './AbsComponent';

export default class Pagination extends AbsComponent {
    #unit = 5;

    constructor(_name = '', _store = {}, _actions = {}, _router = {}, _el = '', _size = 15) {
        super(_name, _store, _actions, _router, _el);
        this.size = _size;
    }

    render(_data) {
        let pageData = {
            current: _data.page,
            total: Math.ceil(_data.total / this.size),
            firstNum: parseInt((_data.page - 1) / this.#unit) * this.#unit + 1,
            nowPageNum: parseInt((_data.page - 1) / this.#unit) + 1,
            lastPageNum: parseInt((Math.ceil(_data.total / this.size) - 1) / this.#unit) + 1,
            page: [],
        };

        pageData.page = this.settingNum(pageData);

        let list = `
            ${pageData.nowPageNum <= 1 ? '' : `<li class="prev"><button data-paging="${pageData.firstNum - 1}"></button></li>`}
            ${pageData.page
                .map(
                    (it) =>
                        `<li class="${it.isActive}">${
                            it.isActive == 'current' ? `${it.num}` : `<button data-paging="${it.num}">${it.num}</button></li>`
                        }`
                )
                .join('')}
            ${
                pageData.nowPageNum >= pageData.lastPageNum
                    ? ''
                    : `<li class="next"><button data-paging="${pageData.firstNum + this.#unit}"></button></li>`
            }`;

        $(this.el).empty().append(list);
        $(this.el).toggle(pageData.total > 1);

        this.addEvents();
    }

    addEvents() {
        const isNcPurple = !!document.querySelector('body')?.classList.contains('ncPurple');
        $(this.el + ' li button').on('click', (e) => {
            this.router.goMultiParam({ page: $(e.currentTarget).data('paging') });
            const scrollTarget = isNcPurple ? document.querySelector('div.container') : 'html';

            const moveY = $('#gameinfoTab').offset().top;
            $(scrollTarget).scrollTop(moveY);
            // $('body').scrollTop(moveY);
        });
    }

    settingNum(_d) {
        let arr = [];
        for (let i = 0; i < this.#unit; i++) {
            let pgNum = _d.firstNum + i;
            if (pgNum > _d.total) continue;

            arr.push({
                num: pgNum,
                isActive: pgNum === _d.current ? 'current' : '',
            });
        }
        return arr;
    }
} // end of class
